const calloutComponentInputSelectableValidator = (schema, answer) => {
  const optionValue = schema.values.find((v) => v.value === answer);
  return !!optionValue;
};
export {
  calloutComponentInputSelectableValidator
};
